module.exports = __webpack_public_path__ + "img/1581908397.845717a7.jpg";